export const SETTINGS_CATEGORIES = [
  {
    key: 'integrations',
    title: 'Integrations',
    description: 'Connect Google Search Console, GA4, ServiceTitan, LSA and other data sources.',
    icon: 'fa-solid fa-plug',
    href: '/mlap/settings/integrations'
  },
  {
    key: 'gsc_ga4',
    title: 'GSC & GA4',
    description: 'Manage which GSC properties and GA4 properties feed MLAP.',
    icon: 'fa-solid fa-chart-line',
    href: '/mlap/settings/gsc_ga4'
  },
  {
    key: 'google_ads',
    title: 'Google Ads',
    description: 'Connect Google Ads and map campaigns and ad groups to locations.',
    icon: 'fa-solid fa-bullhorn',
    href: '/mlap/settings/google_ads'
  },
  {
    key: 'bing_ads',
    title: 'Microsoft Ads',
    description: 'Connect Microsoft Advertising and map campaigns and ad groups to locations.',
    icon: 'fa-brands fa-microsoft',
    href: '/mlap/settings/bing_ads'
  },
  {
    key: 'meta_ads',
    title: 'Meta Ads',
    description: 'Connect Meta Ads and map campaigns and ad sets to locations.',
    icon: 'fa-brands fa-meta',
    href: '/mlap/settings/meta_ads'
  },
  {
    key: 'nextdoor_ads',
    title: 'Nextdoor Ads',
    description: 'Connect Nextdoor Ads and map campaigns and ad groups to locations.',
    icon: 'fa-solid fa-people-roof',
    href: '/mlap/settings/nextdoor_ads'
  },
  {
    key: 'call_rail',
    title: 'CallRail',
    description: 'Connect CallRail to sync tracked calls and attribute them to locations.',
    icon: 'fa-solid fa-phone-volume',
    href: '/mlap/settings/call_rail'
  },
  {
    key: 'bing',
    title: 'Bing Webmaster',
    description: 'Connect Bing Webmaster Tools and map sites and pages to locations.',
    icon: 'fa-solid fa-globe',
    href: '/mlap/settings/bing'
  },
  {
    key: 'service_titan',
    title: 'ServiceTitan',
    description: 'Configure ServiceTitan tenants, jobs sync, business units and campaigns.',
    icon: 'fa-solid fa-screwdriver-wrench',
    href: '/mlap/settings/service_titan'
  },
  {
    key: 'lsa_accounts',
    title: 'LSA Accounts',
    description: 'Link Local Service Ads accounts and see which locations they cover.',
    icon: 'fa-solid fa-badge-check',
    href: '/mlap/settings/lsa_accounts'
  },
  {
    key: 'geogrids',
    title: 'Geogrids',
    description: 'Pick which geogrid configs feed MLAP rankings, per location.',
    icon: 'fa-solid fa-grid-2',
    href: '/mlap/settings/geogrids'
  },
  {
    key: 'audits',
    title: 'Audits',
    description: 'Enable scheduled audits per location and review which run today.',
    icon: 'fa-solid fa-scale-balanced',
    href: '/mlap/settings/audits'
  }
]
